import React from "react";

import codingImg from "../assets/portfolio/coding.jpg";
import dashboardImg from "../assets/portfolio/dashboard.jpg";
import trokitImg from "../assets/portfolio/trokit.jpg";

const projects = [
  {
    img: codingImg,
    alt: "Inxhinier duke punuar në kod për një dyqan online",
    label: "Tregti",
    title: "Platformë e-commerce për ndërmarrje",
    outcomes: ["Pagesë me ndërgjegje PCI", "Synim LCP <2s", "Katalog shumë-rajonësh"],
    body: "Dyqan me trafik të lartë me mjete merchandising, promovime dhe panele operative për ekipet komerciale.",
  },
  {
    img: dashboardImg,
    alt: "Panele analitike biznesi në ekrane",
    label: "Analitikë",
    title: "Suite analitike për drejtim",
    outcomes: ["Qasje sipas roleve", "Eksport & gjurmë auditimi", "KPI afër kohës reale"],
    body: "Shtresë e unifikuar raportimi që lidh shitjet, marketingun dhe financat me detaje që drejtuesit i besojnë.",
  },
  {
    img: trokitImg,
    alt: "Trokit — ikonë zyrtare nga App Store",
    label: "Mobile",
    title: "Trokit — aplikacion iOS",
    outcomes: ["Listime apartamentesh", "Kërkesa & bisedë në app", "Njoftime në kohë reale"],
    body: "Aplikacion për bashkëbanim: postime, kërkesa dhe mesazhe brenda produktit — i publikuar në App Store.",
  },
];

function Portfolio() {
  return (
    <section className="portfolio section-pad" id="projects">
      <div className="container">
        <div className="section-heading">
          <span className="section-tag">Punë të zgjedhura</span>
          <h2>Rezultate, jo vetëm pamje</h2>
          <p>
            Angazhime përfaqësuese që theksojnë arkitekturën, performancën dhe detajin
            operativ që palët e interesuara presin nga një partner senior.
          </p>
        </div>

        <div className="portfolio-grid">
          {projects.map(({ img, alt, label, title, outcomes, body }) => (
            <article key={title} className="portfolio-card">
              <div className="portfolio-image-wrap">
                <img className="portfolio-image" src={img} alt={alt} loading="lazy" />
              </div>
              <div className="portfolio-content">
                <span className="portfolio-label">{label}</span>
                <h3>{title}</h3>
                <ul className="portfolio-outcomes">
                  {outcomes.map((o) => (
                    <li key={o}>{o}</li>
                  ))}
                </ul>
                <p>{body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
